/**
 * Created by psivanappans on 10/03/2022
 * File: AppBanner
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import PropTypes from 'prop-types'
import { Banner } from '@panwds/react-ui'

const AppBanner = ({ info, warning, className = 'tw-p-3 tw-space-y-3' }) => {
  return <>
    <div className={className}>
      {info && <Banner type="inline" appearance="standard" showIcon>
        {info}
      </Banner>}
      {warning && <Banner type="inline" appearance="warning" showIcon>
        {warning}
      </Banner>}
    </div>
  </>
}

AppBanner.propTypes = {
  info: PropTypes.string,
  warning: PropTypes.string
}

export default AppBanner
